import AboutWordpress from "../components/about/AboutWordpress";
import WordpressProjects from "../components/portofolio/WordpressProjects";
import WordpressReview from "../components/testimonial/WordpressReview";
import Contact from "../components/contact/Contact";

const Wordpress = () => {
  return (
    <div>
      <AboutWordpress />
      <WordpressProjects />
      <WordpressReview />
      <Contact />
    </div>
  );
};

export default Wordpress;
